import React from "react";

import { makeStyles, Theme } from "@material-ui/core/styles";

import QuestionHeader, { Props as QuestionHeaderProps } from "./QuestionHeader";
import QuestionCard, { Props as QuestionCardProps } from "./QuestionCard";
import { RadioGroup } from "../RadioGroup";

interface SingleSelectAnswer {
  id: string;
  label: React.ReactNode;
}

interface Props extends QuestionHeaderProps, QuestionCardProps {
  /** The list of options for this question */
  options: SingleSelectAnswer[];
  /** The selected option for this question */
  selectedOption: string;
  /** A function which updates the selected option when a new option is clicked */
  setSelectedOption: (arg0: string) => any;
}

interface FullWidthRadioGroupProps {
  prepopulated?: boolean;
}

const useLabelStyles = makeStyles({
  asterisk: {
    display: "none",
  },
});

const useRadioStyles = makeStyles<Theme, FullWidthRadioGroupProps>((theme) => ({
  radioGroup: (props) => ({
    width: "100%",
    ...(props.prepopulated && {
      "& .MuiRadio-root.Mui-checked": {
        color: theme.palette.info.main,
      },
      "& .MuiRadio-root.Mui-checked + .MuiFormControlLabel-label": {
        color: theme.palette.info.main,
      },
    }),
  }),
}));

export default function SingleSelectQuestion({
  options,
  selectedOption,
  setSelectedOption,
  relevantLinks,
  required,
  ordinal,
  questionText,
  questionType,
  subtext,
  hideQuestionAnswerDivider,
  ...questionCardProps
}: Props) {
  const labelClasses = useLabelStyles();
  const radioClasses = useRadioStyles({ prepopulated: questionCardProps.prepopulated });

  return (
    <QuestionCard {...questionCardProps}>
      <RadioGroup
        labelClasses={labelClasses}
        label={
          <QuestionHeader
            hideQuestionAnswerDivider={hideQuestionAnswerDivider}
            relevantLinks={relevantLinks}
            required={required}
            ordinal={ordinal}
            questionText={questionText}
            questionType={questionType}
            subtext={subtext}
          />
        }
        options={options}
        value={selectedOption}
        onChange={setSelectedOption}
        required={required}
        additionalRadioClasses={radioClasses}
      />
    </QuestionCard>
  );
}
